import type { TFunction } from "i18next";
import type { CityHallStateResponse } from "../../client";
import ElectionsActiveBanner from "../../ui/cityhall/ElectionsActiveBanner";


interface ElderWelcomeBannerProps {
  state: CityHallStateResponse | undefined;
  formatElectionTimeRemaining: (electionEndAt: string | null | undefined) => string;
  t: TFunction;
}

/** Elder dialogue box with welcome copy and optional elections banner. */
function ElderWelcomeBanner({
  state,
  formatElectionTimeRemaining,
  t,
}: ElderWelcomeBannerProps) {
  return (
    <div
      className="flex flex-col items-start self-stretch whitespace-pre-wrap rounded-xl border border-solid border-brand bg-white p-3xl"
    >
      <div
        className="mb-0 [font-family:'Rubik_One',sans-serif] text-[20px] leading-[40px] font-normal text-deep-blue"
      >
        {t("Elder")}
      </div>
      <div
        className="break-words [word-wrap:break-word] [font-family:Lato,sans-serif] text-[18px] leading-[30px] font-normal text-text-dark"
      >
        <div className="mb-lg">
          {t("Welcome to the Web3Islands Town Hall!")}
        </div>
        <div>
          {t("Here you can become the mayor or vote for a friend to become mayor. What would you like to discuss?")}
        </div>

        {/* Elections info inside dialog */}
        {state?.voting_available && (
          <ElectionsActiveBanner
            electionEndAt={state.election_end_at}
            formatElectionTimeRemaining={formatElectionTimeRemaining}
          />
        )}
      </div>
    </div>
  );
}

export default ElderWelcomeBanner;
